export { Planet as default } from './Planet';
